export default function Hero() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const stats = [
    { value: '12,000+', label: '部漫画持续更新' },
    { value: '500万+', label: '月活跃读者' },
    { value: '每日更新', label: '热门连载不等待' },
  ];

  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20anime%20art%20illustration%20with%20warm%20orange%20and%20coral%20gradients%2C%20abstract%20manga%20panel%20composition%2C%20dynamic%20speed%20lines%2C%20soft%20atmospheric%20lighting%2C%20artistic%20watercolor%20texture%2C%20modern%20minimalist%20design%2C%20subtle%20character%20silhouettes%2C%20cinematic%20framing%2C%20warm%20golden%20accents&width=1800&height=900&seq=hero-manga-bg&orientation=landscape"
          alt="妖精动漫网 漫画世界"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 text-primary-200 text-xs font-medium tracking-wide mb-5">
              全网最全免费漫画平台
            </span>

            <h1 className="font-heading font-black text-3xl md:text-4xl lg:text-5xl text-foreground-50 leading-tight mb-4">
              妖精动漫网
              <span className="block text-primary-300 lg:inline lg:ml-3">免费漫画在线阅读</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-100/80 font-medium mb-3">
              下拉式畅读 · 全本免费 · 每日更新
            </p>

            <p className="text-foreground-200/80 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              妖精动漫网汇聚海量正版授权与汉化漫画资源，涵盖热血、恋爱、悬疑、奇幻、搞笑等全品类题材。支持下拉式连续阅读，无需翻页打断沉浸感；每日同步更新热门连载，让追更不落空。无论是经典神作还是新番推荐，这里都是漫画爱好者的精神乐园。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-300">{stat.value}</div>
                  <div className="text-xs md:text-sm text-foreground-300 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => handleNavClick(e, '#index')}
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full cursor-pointer transition-all duration-200 whitespace-nowrap text-sm"
              >
                <i className="ri-book-open-line"></i>
                立即开始阅读
              </a>
              <a
                href="#about"
                onClick={(e) => handleNavClick(e, '#about')}
                className="inline-flex items-center gap-2 px-7 py-3 bg-white/10 hover:bg-white/20 text-foreground-50 font-semibold rounded-full cursor-pointer border border-white/20 transition-all duration-200 whitespace-nowrap text-sm"
              >
                <i className="ri-information-line"></i>
                了解平台
              </a>
            </div>
          </div>

          <div className="flex-1 w-full hidden lg:flex items-center justify-center">
            <div className="relative w-full max-w-[480px] aspect-[4/5] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20beautiful%20anime%20style%20illustration%20featuring%20a%20dynamic%20manga%20reading%20scene%2C%20floating%20comic%20panels%20with%20vibrant%20colors%2C%20warm%20coral%20and%20golden%20tones%2C%20energetic%20composition%2C%20modern%20manga%20aesthetic%2C%20stylized%20Japanese%20comic%20art%2C%20clean%20lines%2C%20soft%20gradient%20background%2C%20cinematic%20lighting%2C%20professional%20illustration%20quality&width=960&height=1200&seq=hero-manga-visual&orientation=portrait"
                alt="妖精动漫网 在线阅读体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}